import React from 'react';

interface ErrorIconProps {
  width?: string;
  height?: string;
  isDarkMode?: boolean;
}

const ErrorIcon: React.FunctionComponent<ErrorIconProps> = ({
  width = '30',
  height = '30',
  isDarkMode = true,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={width}
      height={height}
      viewBox="0 0 48 48"
    >
      <circle cx="24" cy="24" r="22" stroke="red" stroke-width="3" fill="none" />
      <line x1="14" y1="14" x2="34" y2="34" stroke="red" stroke-width="3" />
      <line x1="14" y1="34" x2="34" y2="14" stroke="red" stroke-width="3" />
    </svg>
  );
};

export default ErrorIcon;
